import {
  CurrencyCode,
  IGiftItemResponse,
  formatMoney,
  limitChars,
  transformDate,
} from '@one-tree/library'
import React, { ReactElement } from 'react'

export const getRemaining = (item: IGiftItemResponse): number | string => {
  if (!item.quantity) return 'Unlimited'
  const remaining = item.quantity - (item.quantitySold || 0)
  return remaining
}

export const getTotal = (item: IGiftItemResponse): number => {
  if (!item.prices || item.prices.length === 0) {
    return item.revenueSold ?? 0
  }

  return item.prices.reduce((sum, price) => sum + (price.revenueSold ?? 0), 0)
}

export const getTotalDisplay = (
  item: IGiftItemResponse,
  currencyCode: CurrencyCode,
): ReactElement => {
  if (!item.prices || item.prices.length === 0) {
    return <div>{formatMoney(item.revenueSold ?? 0, currencyCode)}</div>
  }

  return (
    <div>
      {item.prices.map((price) => (
        <div key={price.id}>{formatMoney(price.revenueSold ?? 0, currencyCode)}</div>
      ))}
    </div>
  )
}

export const getPrices = (item: IGiftItemResponse): ReactElement => {
  if (!item.prices || item.prices.length === 0) return <div>General</div>
  return (
    <div>
      {item.prices.map((price) => (
        <div key={price.id}>{limitChars(price.name, 14, true)}</div>
      ))}
    </div>
  )
}

export const getValues = (
  item: IGiftItemResponse,
  currencyCode: CurrencyCode,
): ReactElement => {
  if (!item.prices || item.prices.length === 0) {
    return <div>{formatMoney(item?.value || 0, currencyCode)}</div>
  }
  return (
    <div>
      {item.prices.map((price) => (
        <div key={price.id}>{formatMoney(price.value, currencyCode)}</div>
      ))}
    </div>
  )
}

export const getQuantities = (item: IGiftItemResponse): ReactElement => {
  if (!item.prices || item.prices.length === 0) return <div>{item.quantitySold}</div>
  return (
    <div>
      {item.prices.map((price) => (
        <div key={price.id}>{price.quantitySold}</div>
      ))}
    </div>
  )
}

export const getTotalSold = (items: IGiftItemResponse[]): string => {
  const total = items.reduce((sum, item) => sum + (item.quantitySold || 0), 0)
  return String(total)
}

export const getTotalProfit = (
  items: IGiftItemResponse[],
  currencyCode: CurrencyCode,
): string => {
  const profit = items.reduce((sum, item) => sum + getTotal(item), 0)
  return formatMoney(profit, currencyCode)
}

export const getDate = (date: number | undefined): string => (date ? transformDate(date) : '-')
